'use es6';

import { getFeatures } from 'pricing-pages-lib/api/FeaturesApi';
import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
export const FetchFeaturesRequestTypes = createRequestTypes('FEATURES');
export const FetchFeaturesActions = createRequestActions(FetchFeaturesRequestTypes);
export const fetchFeatures = ({
  highlightedProducts,
  productLine
}) => dispatch => {
  return makeFetchRequest({
    requestActions: FetchFeaturesActions,
    fetch: getFeatures,
    payload: {
      highlightedProducts,
      productLine
    }
  })(dispatch);
};